<template>
  <div>
    <div class="page-header">
      <div class="page-header-left">
        <ol class="breadcrumb ml-0">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'welcome' }">
              <feather type="home" />
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'vendorManagementDashboard' }">
              {{ $t('companyFormAdminView.vendorManagement') }}
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{name: 'vendorManagementFormList'}">
              {{ $t('companyFormAdminView.tdarkDyrlndirmFormalar') }}
            </router-link>
          </li>
          <li
            v-if="form"
            class="breadcrumb-item"
          >
            {{ form.name }}
          </li>
        </ol>
      </div>
    </div>


    <div v-if="!form">
      <div class="alert alert-primary">
        {{ $t('companyFormAdminView.mlumatYklnir') }}
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-body">
              <h4>{{ form.name }}</h4>
              <div v-html="formDescription" />

              <div class="my-2">
                <ProfileTypeBadge
                  class="m-1 cursor-pointer"
                  :is-current="false"
                  :profile="form.profileType"
                  :badge-white="false"
                />  {{ $t('companyFormAdminView.profiliN') }}
              </div>

              <div class="my-2">
                <div v-for="s in sectors">
                  - {{ s.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card">
            <div class="card-body">
              <strong>{{ $t('companyFormAdminView.status') }} </strong>
              <CompanyFormStatus :status="form.status" />

              <div v-if="form.status==='DRAFT'">
                <p>
                  {{ $t('companyFormAdminView.formaQaralamaStatusundadrHazrdaIstnilnDzliiEdBilrs') }}
                </p>

                <button
                  type="button"
                  class="btn  btn-block btn-success my-2"
                  @click="markReady"
                >
                  {{ $t('supplierOutgoingVendorRequest.hazrdr') }}
                </button>

                <router-link
                  :to="{name: 'vendorManagementFormEdit', params:{id: form.id}}"
                  class="btn btn-block btn-primary my-2"
                >
                  {{ $t('companyFormAdminView.redaktEt') }}
                </router-link>

                <button
                  type="button"
                  class="btn  btn-block btn-danger my-2"
                  @click="deleteForm"
                >
                  {{ $t('companyFormAdminView.formanSil') }}
                </button>
              </div>
              <div v-if="form.status==='READY'">
                <p>{{ $t('companyFormAdminView.formannHazrlanmasTamamlanmdrLakinOTdarklrNLatanDey') }} </p>
                <button
                  type="button"
                  class="btn btn-block btn-success my-2"
                  @click="publishForm"
                >
                  {{ $t('companyFormAdminView.yaymla') }}
                </button>


                <router-link
                  :to="{name: 'vendorManagementFormEdit', params:{id: form.id}}"
                  class="btn  btn-block btn-primary my-2"
                >
                  {{ $t('companyFormAdminView.redaktEt') }}
                </router-link>

                <button
                  type="button"
                  class="btn btn-block btn-warning my-2"
                  @click="markArchive"
                >
                  {{ $t('companyFormAdminView.arxivldir') }}
                </button>
              </div>
              <div v-if="form.status==='ACTIVE'">
                <p>
                  {{ $t('companyFormAdminView.formaYaymlanmdrtdarklrIrktinizinTsdiqlnmiTdarkSiya') }}
                </p>

                <button
                  type="button"
                  class="btn btn-block btn-success my-2"
                  @click="shareForm"
                >
                  {{ $t('companyFormAdminView.payla') }}
                </button>

                <router-link
                  :to="{name: 'vendorManagementFormEdit', params:{id: form.id}}"
                  class="btn btn-block btn-primary my-2"
                >
                  {{ $t('companyFormAdminView.redaktEt') }}
                </router-link>

                <button
                  type="button"
                  class="btn btn-block btn-warning my-2"
                  @click="markArchive"
                >
                  {{ $t('companyFormAdminView.arxivldir') }}
                </button>

                <button
                  type="button"
                  class="btn btn-block btn-danger my-2"
                  @click="recallForm"
                >
                  {{ $t('companyFormAdminView.yenidnDyrlndirmSorusuGndr') }}
                </button>
              </div>

              <div v-if="form.status==='ARCHIVE'">
                <p>{{ $t('companyFormAdminView.formaArxivldirilmidirIstifadilrBuFormanGrmrlr') }}</p>

                <button
                  type="button"
                  class="btn btn-block btn-success my-2"
                  @click="publishForm"
                >
                  {{ $t('companyFormAdminView.yendinYaymla') }}
                </button>

                <router-link
                  :to="{name: 'vendorManagementFormEdit', params:{id: form.id}}"
                  class="btn btn-block btn-primary my-2"
                >
                  {{ $t('companyFormAdminView.redaktEt') }}
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="d-flex justify-content-between">
                <div class="lead">
                  {{ $t('companyFormAdminView.sualCavab') }}
                </div>
              </div>
            </div>
            <div class=" list-group list-group-flush">
              <div
                v-if="faq.length<1"
                class="list-group-item py-4"
              >
                {{ $t('companyFormAdminView.buFormaIlBalSualVerilmyib') }}
              </div>

              <div
                v-for="f in faq"
                :key="f.id"
                class="list-group-item py-4"
              >
                <div
                  class="row"
                  style="line-break: anywhere"
                >
                  <div class="col-10">
                    <span class="badge badge-primary">
                      {{ f.company.name }} {{ getCompanyFormat(f.company.format) }}
                    </span> <br>
                    <em v-if="f.status==='REJECTED'">{{ $t('companyFormAdminView.sualLvEdildiyindnGstrilmir') }}</em>
                    <strong v-else>{{ f.question }}</strong>

                    <div
                      v-if="f.status==='NEW'"
                      class="text-danger"
                    >
                      {{ $t('companyFormAdminView.sualCavablanmayb') }}
                    </div>
                    <div v-else-if="f.status==='ANSWERED'">
                      - {{ f.answer }}
                    </div>
                    <div v-else-if="f.status==='REJECTED'">
                      <span class="badge badge-danger">{{ $t('companyFormAdminView.lvEdilib') }}</span> {{ f.answer }}
                    </div>
                  </div>
                  <div class=" col-2 text-right">
                    <div v-if="f.status==='NEW'">
                      <button
                        class="btn btn-sm btn-light-success mb-2"
                        @click="answerFAQ(f)"
                      >
                        <i class="fa fa-commenting" />
                        {{ $t('companyFormAdminView.cavabla') }}
                      </button>
                      <br>
                      <button
                        class="btn btn-sm btn-light-danger"
                        @click="rejectFAQ(f)"
                      >
                        <i class="fa fa-trash" />
                        {{ $t('companyProfile.lvEt') }}
                      </button>
                    </div>
                    <div v-else-if="f.status==='ANSWERED'">
                      <button
                        class="btn btn-sm btn-light-success mb-2"
                        @click="answerFAQ(f)"
                      >
                        <i class="fa fa-pencil" />
                        {{ $t('companyFormAdminView.dyi') }}
                      </button>
                      <br>
                      <button
                        class="btn btn-sm btn-light-danger"
                        @click="rejectFAQ(f)"
                      >
                        <i class="fa fa-trash" />
                        {{ $t('companyProfile.lvEt') }}
                      </button>
                    </div>
                    <div v-else-if="f.status==='REJECTED'">
                      <button
                        class="btn btn-sm btn-light-success"
                        @click="answerFAQ(f)"
                      >
                        <i class="fa fa-commenting" />
                        {{ $t('companyFormAdminView.cavabla') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="lead font-weight-bold">
                    {{ $t('companyFormAdminView.daxilOlanMracitlr') }}
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="requests.length <1"
              class="card-body"
            >
              <div class="alert alert-info">
                {{ $t('supplierOutgoingVendorRequest.uyunMracitTaplmad') }}
              </div>
            </div>


            <template v-for="r in requests">
              <hr class="my-0 py-0">
              <div class="card-body">
                <div class="row mb-3">
                  <div class="col-md-10">
                    <span class="h4">#{{ r.id }}</span> <span class="lead">{{ r.companyForm.name }}</span>
                  </div>
                  <div class="col-md-2 text-right">
                    <CompanyFormRequestStatus :status="r.status" />
                    <span
                      v-if="r.unreadMessageCountProcurement>0"
                      class="badge badge-danger blink"
                    >
                      {{
                        $t('companyFormAdminView.runreadmessagecountprocurementYeniMesaj', {count: r.unreadMessageCountProcurement})
                      }}
                    </span>
                    <span
                      v-else-if="r.conversationActive"
                      class="badge badge-warning"
                    >
                      {{ $t('companyFormAdminView.mzakirAktivdir') }}
                    </span>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-5">
                    <strong>{{ $t('companyFormAdminView.irkt') }} </strong> {{ r.company.name }} {{ getCompanyFormat(r.company.format) }} <br>
                    <strong>{{ $t('supplierOutgoingVendorRequest.mllif') }} </strong> {{ r.user.name }} {{ r.user.surname }} <br>
                  </div>
                  <div class="col-md-7">
                    <strong>{{ $t('companyFormAdminView.sonDyiiklik') }} </strong> {{ r.lastUpdateTime }} <br>
                    <strong>{{ $t('companyFormAdminView.gndrilib') }} </strong> {{ r.sendTime || '-' }} <br>
                  </div>


                  <div class="col-md-10">
                    <div v-if=" r.companyForm.profileType === 'SUPPLIER'">
                      <strong>{{ $t('supplierOutgoingVendorRequest.faliyytSahlri') }} </strong>
                      <div v-for=" s in getRequestSectorList(r)">
                        - {{ s.sector.name }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 d-flex align-items-end justify-content-end ">
                    <button
                      class="btn btn-sm btn-light-primary mt-auto"
                      @click="showRequestDetails(r.id)"
                    >
                      {{ $t('supplierOutgoingVendorRequest.trafl') }} <i class="fa fa-chevron-right" />
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>


    <b-modal
      id="modal-share"
      centered
      :title="$t('companyFormAdminView.paylam')"
      scrollable
      ok-only
      class="theme-modal"
      :busy="false"
    >
      <div v-if="form">
        {{ $t('companyFormAdminView.paylamNLink') }} <br>
        <code
          v-if="form"
          id="shareLink"
        >{{ formLink }}</code>
        <a
          class="pointer"
          @click.prevent="copyLink"
        >
          <feather
            type="copy"
            size="12"
          />
        </a>
        <a
          class="pointer ml-2"
          :href="formLink"
          target="_blank"
        >
          <feather
            type="external-link"
            size="12"
          />
        </a>

        <div class="my-2">
          <ShareNetwork
            network="facebook"
            :url="formLink"
            :title="form.name"
            :description="form.description"
            class="btn btn-primary m-2"
          >
            <i
              class="fa fa-fw fa-facebook"
              aria-hidden="true"
            />
          </ShareNetwork>
          <ShareNetwork
            network="email"
            :url="formLink"
            :title="form.name"
            :description="form.description"
            class="btn btn-primary m-2"
          >
            <i
              class="fa fa-fw fa-at"
              aria-hidden="true"
            />
          </ShareNetwork>
          <ShareNetwork
            network="linkedIn"
            :url="formLink"
            :title="form.name"
            class="btn btn-primary  m-2"
          >
            <i
              class="fa fa-fw fa-linkedin"
              aria-hidden="true"
            />
          </ShareNetwork>
          <ShareNetwork
            network="telegram"
            :url="formLink"
            :title="form.name"
            :description="form.description"
            class="btn btn-info  m-2"
          >
            <i
              class="fa fa-fw fa-telegram"
              aria-hidden="true"
            />
          </ShareNetwork>
          <ShareNetwork
            network="whatsapp"
            :url="formLink"
            :title="form.name"
            :description="form.description"
            class="btn btn-success  m-2"
          >
            <i
              class="fa fa-fw fa-whatsapp"
              aria-hidden="true"
            />
          </ShareNetwork>
        </div>
      </div>
    </b-modal>


    <b-modal
      id="modal-vendor-request"
      size="xl"
      centered
      :title="$t('supplierOutgoingVendorRequest.mracitDetallar')"
      scrollable
      :hide-footer="true"
      class="theme-modal"
      :busy="false"
      :no-enforce-focus="true"
      @close="loadRequestList"
    >
      <VendorRequestDetailsReceiver
        v-if="activeRequestId>0"
        :active-request-id="activeRequestId"
        @confirmRequest="confirmRequest($event)"
      />
    </b-modal>

    <b-modal
      id="modal-request-confirm"
      size="lg"
      centered
      :title="$t('companyFormAdminView.mracitinTsdiqlnmsi')"
      scrollable
      :hide-footer="true"
      class="theme-modal"
      :busy="false"
      :no-enforce-focus="true"
      @close="loadRequestList"
    >
      <ConfirmVendorRequestModal
        :confirm-request-details="confirmRequestDetails"
        @updated="showRequestDetails(confirmRequestDetails.requestId)"
      />
    </b-modal>


    <b-modal
      id="modal-faq-answer"
      centered
      :title="$t('requestFaq.cavabla')"
      :hide-footer="true"
      class="theme-modal"
    >
      <form
        v-if="activeFaq"
        @submit.prevent="submitFaqAnswer"
      >
        <div class="mb-2">
          <span class="badge badge-primary">
            {{ activeFaq.company.name }} {{ getCompanyFormat(activeFaq.company.format) }}
          </span> <br>
          <strong>{{ activeFaq.question }}</strong>
        </div>

        <div class="mb-3">
          <label>{{ $t('companyFormAdminView.cavab') }}</label>
          <textarea
            v-model="activeFaq.answer"
            rows="3"
            class="form-control"
            type="text"
            required
            :placeholder="$t('companyFormAdminView.cavabMtniniDaxilEdin')"
          />

          <span class="text-danger small">
            {{ $t('companyFormAdminView.daxilEtdiyinizCavabBtnIstifadilrGstrilck') }}
          </span>
        </div>
        <div class="mb-3">
          <button
            class="btn btn-success mr-2"
            type="submit"
          >
            <span>{{ $t('companyFormAdminView.cavabla') }}</span>
          </button>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {
  answerFaqQuestion,
  companyFormAction,
  getFormFaq,
  getFormIncomingRequests,
  getMyForm,
  handleErrors,
  rejectFaqQuestion
} from "@/repositories/VendorManagementRepository";
import CompanyFormStatus from "@/pages/scc/vendorManagement/utils/CompanyFormStatus.vue";
import {getCompanyFormat, getPhoto, getProfileName} from "@/repositories/Utils";
import VendorRequestDetailsReceiver from "@/pages/scc/vendorManagement/VendorRequestDetailsReceiver.vue";
import ConfirmVendorRequestModal from "@/pages/scc/vendorManagement/ConfirmVendorRequestModal.vue";
import CompanyFormRequestStatus from "@/pages/scc/vendorManagement/utils/CompanyFormRequestStatus.vue";
import ProfileTypeBadge from "@/components/ProfileTypeBadge.vue";


export default {
  components: {
    ProfileTypeBadge,
    CompanyFormRequestStatus,
    ConfirmVendorRequestModal,
    VendorRequestDetailsReceiver,
    CompanyFormStatus
  },
  data() {
    return {
      mediaBase: mediaBase,
      form: null,
      sectors: [],
      sections: [],
      inputs: [],
      faq: [],
      faqAnswerText: '',
      formLink: '',

      requests: [],
      activeRequestId: 0,
      confirmRequestDetails: null,

      activeFaq: null

    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),
    formDescription: function () {
      if (this.form && this.form.description) {
        return this.form.description.replace(/(?:\r\n|\r|\n)/g, '<br>');
      } else {
        return '';
      }
    }
  },
  mounted() {

    this.getFormDetails();

  },
  methods: {
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    getProfileName(keyword) {
      return getProfileName(keyword,this.i18n);
    },

    getPhoto(path, size) {
      return getPhoto(path, size);
    },
    getFormDetails() {

      getMyForm(this.token, this.$route.params.id, this.$i18n.locale).then(data => {
        if (data.code === 200) {
          this.form = data.form;
          this.sectors = data.sectors;
          this.sections = data.sections;
          this.inputs = data.inputs;

          this.formLink = window.location.origin + "/form/" + data.form.id;

          this.loadFaqList();
          this.loadRequestList();

        } else if (data.code === 404) {
          this.$swal({
            title: this.$t("general.notFound"),
            text: this.$t("axtrdgnzFrmTpldm"),
            icon: 'error'
          }).then(() => {
            this.$router.back();
          })
        } else {
          handleErrors(this.$swal, data, null);
        }
      })
    },

    markReady() {

      this.$swal({
        title: this.$t("generalModal.warningTitle"),
        icon: 'question',
        text: this.$t("companyFormEdit.modalText"),
        showCancelButton: true,
        confirmButtonText: this.$t("supplierOutgoingVendorRequest.hazrdr"),
        cancelButtonText: this.$t("companyProfile.lvEt2"),
      }).then((result) => {
        if (result.value) {
          companyFormAction(this.token, this.form.id, 'ready', '').then(data => {
            if (data.code === 200) {
              this.getFormDetails();
            } else {
              handleErrors(this.$swal, data, null);
            }
          })
        }
      });
    },

    publishForm() {

      this.$swal({
        title: this.$t("generalModal.warningTitle"),
        icon: 'question',
        text: this.$t("fmrnYymldgnzHldTdrk"),
        showCancelButton: true,
        confirmButtonText: this.$t("request.yayimla"),
        cancelButtonText: this.$t("companyProfile.lvEt2"),
      }).then((result) => {
        if (result.value) {
          companyFormAction(this.token, this.form.id, 'publish', '').then(data => {
            if (data.code === 200) {
              this.getFormDetails();
            } else {
              handleErrors(this.$swal, data, null);
            }
          })
        }
      });
    },

    shareForm() {

      this.$bvModal.show('modal-share')
    },

    markArchive() {

      this.$swal({
        title: this.$t("generalModal.warningTitle"),
        icon: 'question',
        text: this.$t("frmArxlsdrdynHldIstdc"),
        showCancelButton: true,
        confirmButtonText: this.$t("companyFormAdminView.arxivldir"),
        cancelButtonText: this.$t("companyProfile.lvEt2"),
      }).then((result) => {
        if (result.value) {
          companyFormAction(this.token, this.form.id, 'archive', '').then(data => {
            if (data.code === 200) {
              this.getFormDetails();
            } else {
              handleErrors(this.$swal, data, null);
            }
          })
        }
      });
    },
    deleteForm() {

      this.$swal({
        title: this.$t("generalModal.warningTitle"),
        icon: 'question',
        text:  this.$t("frmSlmkIstdynzEmnsz"),
        showCancelButton: true,
        confirmButtonText: this.$t("sil"),
        cancelButtonText: this.$t("companyProfile.lvEt2"),
      }).then((result) => {
        if (result.value) {
          companyFormAction(this.token, this.form.id, 'delete', '').then(data => {
            if (data.code === 200) {
              this.getFormDetails();
            } else {
              handleErrors(this.$swal, data, null);
            }
          })
        }
      });
    },

    recallForm() {

      this.$swal({
        title: this.$t("generalModal.warningTitle"),
        icon: 'question',
        text: this.$t("yndnSrgldgnzHld"),
        input: 'textarea',
        showCancelButton: true,
        confirmButtonText: this.$t("srgl"),
        cancelButtonText: this.$t("companyProfile.lvEt2"),
      }).then((result) => {
        if (result.value) {
          companyFormAction(this.token, this.form.id, 'recall', result.value).then(data => {
            if (data.code === 200) {
              this.getFormDetails();
            } else {
              handleErrors(this.$swal, data, null);
            }
          })
        }
      });
    },

    showRequestDetails(id) {
      this.activeRequestId = id;
      this.$bvModal.show('modal-vendor-request');
    },

    loadRequestList() {
      getFormIncomingRequests(this.token, this.$route.params.id).then(data => {
        this.requests = data;
      })
    },


    getRequestSectorList(r) {

      if (r.sectors) {
        let selectedIds = r.sectors.split(',');
        return r.companyForm.sectors.filter(s => selectedIds.indexOf(s.sector.id + '') > -1);
      } else {
        return [];
      }
    },

    confirmRequest(data) {
      this.confirmRequestDetails = data;
      this.$bvModal.hide('modal-vendor-request');
      this.$bvModal.show('modal-request-confirm')
    },

    loadFaqList() {
      getFormFaq(this.token, this.form.id).then(list => {
        this.faq = list;
      })
    },

    copyLink() {
      navigator.clipboard.writeText(this.formLink);
      alert(this.$t("kcrld"))
    },

    answerFAQ(faq) {
      this.activeFaq = {...faq};
      this.$bvModal.show('modal-faq-answer');
    },

    submitFaqAnswer() {
      answerFaqQuestion(this.token, this.activeFaq.id, this.activeFaq.answer).then(data => {
        if (data.code === 200) {
          this.loadFaqList();
          this.$bvModal.hide('modal-faq-answer');
        } else {
          handleErrors(this.$swal, data, null);
        }
      });
    },

    rejectFAQ(faq) {

      this.$swal({
        title: faq.question,
        icon: 'question',
        text: this.$t("lgvEdlmSbb"),
        input: 'textarea',
        showCancelButton: true,
        confirmButtonText: this.$t("companyProfile.lvEt2"),
        cancelButtonText: this.$t("conversationDetails.bala"),
      }).then((result) => {
        if (result.value) {
          rejectFaqQuestion(this.token, faq.id, result.value).then(data => {
            if (data.code === 200) {
              this.loadFaqList();
            } else {
              handleErrors(this.$swal, data, null);
            }
          })
        }
      });
    },
  }
}
</script>
